var _Path, _Path2, _Path3, _Path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgGlobeOutline(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M8.5 1.594a6.906 6.906 0 100 13.813 6.906 6.906 0 000-13.813z",
    stroke: "#242424",
    strokeWidth: 0.708,
    strokeMiterlimit: 10
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M8.5 1.594c-1.928 0-3.741 3.092-3.741 6.906 0 3.814 1.813 6.906 3.741 6.906 1.928 0 3.741-3.092 3.741-6.906 0-3.814-1.813-6.906-3.741-6.906z",
    stroke: "#242424",
    strokeWidth: 0.708,
    strokeMiterlimit: 10
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M3.896 3.896c1.27.901 2.868 1.439 4.604 1.439 1.736 0 3.335-.538 4.604-1.44M13.104 13.104c-1.27-.901-2.868-1.439-4.604-1.439-1.736 0-3.335.538-4.604 1.44",
    stroke: "#242424",
    strokeWidth: 0.708,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M8.5 1.594v13.812M15.406 8.5H1.594",
    stroke: "#242424",
    strokeWidth: 0.708,
    strokeMiterlimit: 10
  })));
}

export default SvgGlobeOutline;